import BigNumber from 'bignumber.js';

BigNumber.config({
    FORMAT: {
        decimalSeparator: '.',
        fractionGroupSeparator: '',
        fractionGroupSize: 0,
        groupSeparator: '',
        groupSize: 0,
        prefix: '',
        secondaryGroupSize: 0,
        suffix: '',
    },
    EXPONENTIAL_AT: 1e9,
});
